import { render, staticRenderFns } from "./channel-overview.vue?vue&type=template&id=007ad23f&scoped=true&lang=pug"
import script from "./channel-overview.vue?vue&type=script&lang=ts"
export * from "./channel-overview.vue?vue&type=script&lang=ts"
import style0 from "./channel-overview.vue?vue&type=style&index=0&id=007ad23f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ad23f",
  null
  
)

export default component.exports